import React from "react";
import { useSearchParams } from "react-router-dom";
import { useStudentsLists } from "../../../hooks/students/useStudentsLists.hooks";
import { useStudentListFilters } from "../../../hooks/filterHooks/useStudentFilterHooks";
import { StudentList } from "./StudentsList";

export const GraduatedStudentList = () => {
  const { filters } = useStudentListFilters("GRADUATED_STUDENT");
  const [searchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "") || 1;
  const { page: _page, ...appliedFilters } = filters || {};

  const { isLoading: isStudentsListLoading, data: studentsList } =
    useStudentsLists({
      page,
      filters: {
        ...appliedFilters,
        onlyGraduatedStudents: true,
      },
    });

  return (
    <StudentList
      isStudentsListLoading={isStudentsListLoading}
      studentsList={studentsList}
      studentListNameSpace="GRADUATED_STUDENT"
    />
  );
};
